<template>
  <div class="box">
    <img class="activity-bg" src="../../../../static/model-bg9.jpg" alt="" />
    <div class="activity-content">
      <div
        class="activity-btn"
        @click="goTopay(item)"
        :class="status != 2 ? 'default-btn' : ''"
        v-for="(item, index) in materialParamsDTO.materialParamsDetailDTOList"
        :key="index"
      >
        <div
          v-if="status == 1"
          style="display: flex;
            align-items: center;
            justify-content: center;
            font-weight: bold;
          "
        >
          活动尚未开始
        </div>
        <div
          v-if="status == 0"
          style="display: flex;
            align-items: center;
            justify-content: center;
            font-weight: bold;
          "
        >
          活动已下线
        </div>
        <div
          v-if="status == 3"
          style="display: flex;
            align-items: center;
            justify-content: center;
            font-weight: bold;
          "
        >
          活动已结束
        </div>
        <div v-if="status == 2 && item.materialParamsDetailType == 1">
          <div>
            充<span>{{ item.rechargeMoney }}</span
            >多送<span>{{ item.giveAwayMoney }}</span>
          </div>
          <p>
            共得{{item.totalbookCoin }}书币
          </p>
        </div>
        <div v-if="status == 2 && item.materialParamsDetailType == 2">
          <div>
            充<span>{{ item.rechargeMoney }}</span>
            <em v-if="item.giveAwayMember == 4">包年</em>
            <em v-if="item.giveAwayMember == 3">包半年</em>
            <em v-if="item.giveAwayMember == 2">包季</em>
            <em v-if="item.giveAwayMember == 1">包月</em>
            <em v-if="item.giveAwayMember == 0">包周</em>
          </div>
          <p>畅享所有图书</p>
        </div>
      </div>
      <div class="activity-tip">
        <p>活动规则</p>
        <p>
          1、活动时间：即日起至<span>{{ endTime }}</span
          >
        </p>
        <p>
          2、本次活动
          <span v-if="purchaseLimitDTO.purchaseLimitType == 2"
            >参与次数不限</span
          >
          <span v-if="purchaseLimitDTO.purchaseLimitType == 1"
            >每天仅限参与{{ purchaseLimitDTO.purchaseLimitValue }}次</span
          >
          <span v-if="purchaseLimitDTO.purchaseLimitType == 0"
            >每人仅限参与{{ purchaseLimitDTO.purchaseLimitValue }}次</span
          >
        </p>
        <p>3、此充值为书币充值，一经充值不支持退款</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["status", "materialParamsDTO", "endTime", "purchaseLimitDTO"],
  data() {
    return {};
  },
  watch: {
    materialParamsDTO: {
      handler: function (val) {
        console.log(val);
      },
      deep: true,
    },
    purchaseLimitDTO: {
      handler: function (val) {
        console.log(val);
      },
      deep: true,
    },
  },
  methods: {
    goTopay(item) {
      this.$emit("payActivity", item);
    },
  },
};
</script>
<style scoped>
em {
  font-style: initial;
}
.box {
  position: relative;
}
.activity-bg {
  width: 100%;
  display: block;
}
.activity-content {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: calc(245px + env(safe-area-inset-top));
}
.activity-btn {
  background-image: linear-gradient(-180deg, #ffe500 23%, #ff9b02 100%);
  border-radius: 100px;
  width: 283px;
  height: 74px;
  text-align: center;
  overflow: hidden;
  margin-bottom: 10px;
}
.activity-btn > div {
  font-size: 25px;
  color: #333333;
  letter-spacing: 1px;
  border-radius: 100px;
  border: 1px solid #fff4e4;
  margin: 3px;
  height: 66px;
  width: 275px;
}
.activity-btn > div > div {
  line-height: 36px;
  font-weight: bold;
  margin-top: 5px;
}
.activity-btn > div > div > span {
  color: #e31a0b;
}
.activity-btn > div > p {
  font-size: 15px;
  color: #e31a0b;
}
.default-btn {
  background: #cfcfcf;
  box-shadow: 0 2px 4px 0 rgba(110, 110, 110, 0.5);
  border-radius: 100px;
}
.default-btn > div,
.default-btn > div > div > span,
.default-btn > div > p {
  color: #636363;
}
.activity-content > .activity-tip {
  text-align: left;
  margin: 0 auto;
  margin-top: 2px;
}
.activity-tip p:nth-of-type(1) {
  text-align: center;
  margin-bottom: 6px;
  font-size: 12px;
}
.activity-tip p {
   white-space: nowrap;
  font-size: 12px;
  color: #ffffff;
  line-height: 17px;
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/view/bookModelActivity/compontent/modelnine.vue